import { render } from "./Timer.vue?vue&type=template&id=606ab678"
import script from "./Timer.vue?vue&type=script&lang=js"
export * from "./Timer.vue?vue&type=script&lang=js"
script.render = render

export default script